import useSWR from 'swr';

import request from '@/utils/request';
import type * as Type from '@/common/interface';

export const useCommonConfig = () => {
  const apiUrl = `/answer/admin/api/config/common`;
  const { data, error, mutate } = useSWR<Type.CommonConfig, Error>(
    [apiUrl],
    request.instance.get,
  );

  return {
    data,
    isLoading: !data && !error,
    error,
    mutate,
  };
};

export const updateCommonConfig = (params: Type.CommonConfig) => {
  const apiUrl = `/answer/admin/api/config/common`;
  return request.put(apiUrl, params);
};

export const resetApiToken = () => {
  const apiUrl = `/answer/admin/api/config/common/reset-api-token`;
  return request.put(apiUrl);
};
